import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';


// Tabs
import TeamsEditTab from './Elements/TeamsEditTab';
import TeamTrainingMattersTab from './Elements/TeamTrainingMattersTab';
import TeamStaffsTab from './Elements/TeamStaffsTab';
import TeamTasksTab from './Elements/TeamTasksTab';
import TrainingAvaliationsTab from './Elements/TrainingAvaliationsTab';

class TeamsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      modal: false,
      moodle_logs_modal: false,
      moodle_logs_loading: false,
      moodle_logs: [],
      loaded: 0,
      team_data: {},
      treinamento: {},
      training_avaliation_staffs: {},
      materias: {},
      dificuldades: {},
      matter_moodle_ids: {},
      lista_treinamentos: {},
      key: 1,
      url: 'undefined',
      message: 'Clique aqui para ser redirecionado.',
      errors_listing: false,
      errors_messages: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.exportMoodle = this.exportMoodle.bind(this);
    this.errorsMoodle = this.errorsMoodle.bind(this);
    this.openMoodleLogs = this.openMoodleLogs.bind(this);
    this.loadMoodleLogs = this.loadMoodleLogs.bind(this);

    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
    this.refreshData = this.refreshData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/turma/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/turmas');
        if (responseJson.status === 'success') {
          self.setState({
            team_data: responseJson.data,
            sigmec_treinamentos_lista: responseJson.sigmec_trainings_list || [],
            sigtrip_treinamentos_lista: responseJson.sigtrip_trainings_list || [],
            sigtrip_selected_list: responseJson.sigtrip_selected_list || [],
            sigmec_selected_list: responseJson.sigmec_selected_list || [],
            matter_moodle_ids: responseJson.matter_moodle_ids || {},
            training_avaliation_staffs: responseJson.avaliation_staffs || {}
          });
        }
      }).then(() => {
        var url = config.get('api') + '/turma/buscar_treinamento/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({
              treinamento: responseJson.data.training,
              materias: responseJson.data.team_training_matter
            });
          }
      }).then(() => {
        var url = config.get('api') + '/turma/alunos/buscar_alunos/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            var alunos = responseJson.data && responseJson.data.infos ? responseJson.data.infos : responseJson.data;
            var avaliation = responseJson.data && typeof responseJson.data.avaliation !== 'undefined' ? responseJson.data.avaliation : 0;
            self.setState({
              alunos: alunos,
              avaliation: avaliation
            });
          }
      }).then(() => {
        var url = config.get('api') + '/turma/buscar_tarefas/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({tarefas: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/provas/dificuldade/listar';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({dificuldades: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/treinamentos/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({lista_treinamentos: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/alunos/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
              self.setState({lista_alunos: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/instrutores/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
              self.setState({lista_instrutores: responseJson.data});
          }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); }); }); }); }); }); }); 
    });
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  refreshData(event) {
    var self = this;
    if(typeof event.data.url !== 'undefined') {
      self.setState({modal: true, url: event.data.url});
      self.handleAlert('', '', 'closed');
    } else {
      var header = this.refs.request_api.header('application/json');
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      var url = config.get('api') + '/turma/buscar_treinamento/'+self.props.match.params.id;
      Promise.resolve(header).then(function(value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({
              treinamento: responseJson.data.training,
              materias: responseJson.data.team_training_matter
            });
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }
  }
  
  refreshTable(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var url = config.get('api') + '/turma/alunos/buscar_alunos/'+self.props.match.params.id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var alunos = responseJson.data && responseJson.data.infos ? responseJson.data.infos : responseJson.data;
          var avaliation = responseJson.data && typeof responseJson.data.avaliation !== 'undefined' ? responseJson.data.avaliation : 0;
          self.setState({
            alunos: alunos,
            avaliation: avaliation
          });
        }
      });
    });
  }

  exportMoodle(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      team_id: this.state.team_data.id,
      type: 'full',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/enviar/moodle', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({loaded: 0});
          self.refreshData(responseJson);
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          self.errorsMoodle(responseJson.data);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  openMoodleLogs(event) {
    if (event) {
      event.preventDefault();
    }
    this.setState({moodle_logs_modal: true}, this.loadMoodleLogs);
  }

  loadMoodleLogs() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({moodle_logs_loading: true});
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/moodle/logs/turma/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson && responseJson.status === 'success') {
          self.setState({moodle_logs: responseJson.data || []});
        } else {
          self.setState({moodle_logs: []});
          if (responseJson && responseJson.message) {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }
        self.setState({moodle_logs_loading: false});
      });
    });
  }

  errorsMoodle(value) {
    this.setState({errors_messages: value, errors_listing: true});
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => this.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>A integração com o Moodle retornou os seguintes erros:</strong>
          {Object.keys(this.state.errors_messages).map(function(k) {
            var message = this.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          }, this)}
        </div>
      }
      <h3 className="page-title pull-left">Turma Nº {this.state.team_data.code_str} - {this.state.team_data.name}</h3>
      <div className="grid-buttons pull-right">
        <button className="btn btn-danger" onClick={this.exportMoodle}><i className="fa fa-download"></i> Moodle - Integrar</button>
        <button className="btn btn-info" onClick={this.openMoodleLogs}><i className="fa fa-fw fa-list"></i> Moodle - Integrações</button>
        <Dropdown id="export-data">
          <Dropdown.Toggle bsStyle={'primary'}>
            <i className="fa fa-fw fa-file-pdf-o"></i> Exportações
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <MenuItem onSelect={this.export} eventKey={'/exportar/listagem/alunos/'}>Lista de alunos</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/exportar/controle/pagamentos/diarias/'}>Controle interno pgto diárias</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/exportar/capa/arquivamento/'}>Capa de arquivamento</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/exportar/resultado/provas/turma/'}>Resultado de provas</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
        <Link to="/turmas" className="btn btn-default"><i className="fa fa-chevron-left"></i> Voltar</Link>
      </div> 
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id={'team-tabs'}>
        <Tab eventKey={1} title="Alunos">
          <TeamStaffsTab handleAlert={this.handleAlert} avaliation={this.state.avaliation} alunos={this.state.alunos} lista_alunos={this.state.lista_alunos} team_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={3} title="Dados da turma">
          <TeamsEditTab sigtrip_selected_list={this.state.sigtrip_selected_list} sigmec_selected_list={this.state.sigmec_selected_list} handleAlert={this.handleAlert} sigtrip_treinamentos_lista={this.state.sigtrip_treinamentos_lista} sigmec_treinamentos_lista={this.state.sigmec_treinamentos_lista} team_data={this.state.team_data} lista_treinamentos={this.state.lista_treinamentos} team_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={2} title="Matérias">
          <TeamTrainingMattersTab refreshData={this.refreshData} handleAlert={this.handleAlert} team_data={this.state.team_data} team_id={this.props.match.params.id} lista_instrutores={this.state.lista_instrutores} dificuldades={this.state.dificuldades} materias={this.state.materias} matter_moodle_ids={this.state.matter_moodle_ids} errorsMoodle={this.errorsMoodle} />
        </Tab>
        <Tab eventKey={4} title="Tarefas a fazer">
          <TeamTasksTab handleAlert={this.handleAlert} tarefas={this.state.tarefas} team_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={5} title="Avaliações de treinamentos">
          <TrainingAvaliationsTab handleAlert={this.handleAlert} training_avaliation_staffs={this.state.training_avaliation_staffs} team_id={this.props.match.params.id} />
        </Tab>
      </Tabs>
      <Modal show={this.state.moodle_logs_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ moodle_logs_modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <h4>Integrações Moodle</h4>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <div className="alert alert-info">
              Quando o retorno estiver vazio, a requisição foi enviada e está aguardando resposta do Moodle.
            </div>
            {this.state.moodle_logs_loading &&
              <p>Carregando integrações...</p>
            }
            {!this.state.moodle_logs_loading && this.state.moodle_logs.length === 0 &&
              <p>Não há integrações registradas para esta turma.</p>
            }
            {!this.state.moodle_logs_loading && this.state.moodle_logs.length > 0 &&
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th className="text-center" style={{width: '6%'}}>ID</th>
                      <th>Função / URL</th>
                      <th className="text-center" style={{width: '12%'}}>Enviado</th>
                      <th className="text-center" style={{width: '12%'}}>Retorno</th>
                      <th className="text-center" style={{width: '6%'}}>HTTP</th>
                      <th className="text-center" style={{width: '10%'}}>Arquivos</th>
                      <th>Erros</th>
                      <th>Resposta</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.moodle_logs.map(function(log) {
                      var retorno = log.response_received_at ? log.response_received_at : <span className="label label-warning">Aguardando retorno</span>;
                      return (
                        <tr key={log.id}>
                          <td className="text-center">{log.id}</td>
                          <td>
                            <strong>{log.function}</strong>
                            <div style={{fontSize: 11, wordBreak: 'break-word'}}>{log.url}</div>
                          </td>
                          <td className="text-center">{log.request_sent_at || '-'}</td>
                          <td className="text-center">{retorno}</td>
                          <td className="text-center">{log.http_code || '-'}</td>
                          <td className="text-center">
                            {log.request_file ? <button className="btn btn-default btn-xs" onClick={() => { window.open(config.get('cdn') + '/' + log.request_file); }}><i className="fa fa-fw fa-download"></i> Req</button> : '-'}
                            {log.response_file ? <button className="btn btn-default btn-xs" style={{marginLeft: 5}} onClick={() => { window.open(config.get('cdn') + '/' + log.response_file); }}><i className="fa fa-fw fa-download"></i> Resp</button> : ''}
                          </td>
                          <td>
                            <div style={{maxWidth: 260, maxHeight: 120, overflowY: 'auto', wordBreak: 'break-word', whiteSpace: 'pre-wrap'}}>
                              {log.errors || '-'}
                            </div>
                          </td>
                          <td>
                            <div style={{maxWidth: 260, maxHeight: 120, overflowY: 'auto', wordBreak: 'break-word', whiteSpace: 'pre-wrap'}}>
                              {log.response || '-'}
                            </div>
                          </td>
                        </tr>
                      );
                    }, this)}
                  </tbody>
                </table>
              </div>
            }
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ moodle_logs_modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
      </Modal>
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <h3>{this.state.url}</h3>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default TeamsEdit;



// WEBPACK FOOTER //
// ./src/Components/Teams/TeamsEdit.js